<template>
  <div class="mb-3">
    <h2 class="fw-light d-flex align-items-center mb-0">
      <router-link
        to=""
        class="d-flex align-items-center me-2"
        title="Voltar"
        @click="$router.go(-1)"
      >
        <i class="ph-caret-circle-left ph-2x" />
      </router-link>
      Editar Medição
    </h2>
  </div>
  <LoadingData v-if="isLoading" />
  <EditMeasure v-else :measure="measure" @getMeasure="getMeasure" />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import EditMeasure from '@/components/documents/measures/EditMeasure.vue'
import { mapGetters } from 'vuex'
import MeasureStatusEnum from '@/enum/measureStatusEnum'

export default {
  name: 'MeasureEdit',

  components: {
    LoadingData,
    EditMeasure,
  },

  data() {
    return {
      isLoading: true,
      measureId: this.$route.params.id,
      measure: null,
    }
  },

  computed: {
    ...mapGetters(['user']),
  },

  methods: {
    async getMeasure() {
      try {
        this.isloading = true

        this.measure = await this.$store.dispatch('getMeasure', this.measureId)

        if (this.user.codUsuario !== this.measure.user) {
          this.$root.$refs.notification.warning(
            'Você não é o usuário que realizou a medição e, portanto, não pode editá-la.',
          )
          this.$router.push({
            name: 'Home',
          })
          return
        }

        if (
          this.measure.status !== MeasureStatusEnum.AGUARDANDO_APROVACAO &&
          this.measure.status !== MeasureStatusEnum.REPROVADO
        ) {
          this.$root.$refs.notification.warning(
            'O status atual da medição não permite edição.',
          )
          this.$router.push({
            name: 'Home',
          })
          return
        }

        this.isLoading = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getMeasure()
  },
}
</script>
